import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, Fragment as _Fragment, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, renderList as _renderList } from "vue";
const _hoisted_1 = { class: "data-item integration" };
const _hoisted_2 = { class: "data-item__header" };
const _hoisted_3 = { class: "data-item__nav" };
const _hoisted_4 = { class: "data-item__topic" };
const _hoisted_5 = { class: "data-item__title" };
const _hoisted_6 = { class: "data-item__meta" };
const _hoisted_7 = {
    key: 0,
    class: "data-item__facts"
};
const _hoisted_8 = {
    key: 1,
    class: "data-item__facts"
};
const _hoisted_9 = { class: "data-item__content" };
const _hoisted_10 = { class: "data-item__section" };
const _hoisted_11 = {
    key: 0,
    class: "integration__description"
};
const _hoisted_12 = ["href"];
const _hoisted_13 = { class: "data-item__section" };
const _hoisted_14 = { class: "data-item__section-title" };
const _hoisted_15 = { class: "integration__enabled" };
const _hoisted_16 = { class: "checkbox" };
const _hoisted_17 = ["disabled"];
const _hoisted_18 = { class: "integration__enabled-label" };
import { onMounted, onUnmounted, ref, watch } from 'vue';
import { useRoute } from "vue-router";
import events from "@astina/paloma-common-ui/src/services/EventBus";
import Fact from "@astina/paloma-common-ui/src/components/Fact.vue";
import Spinner from "@astina/paloma-common-ui/src/components/Spinner.vue";
import shopIntegrationsRepository from '../services/ShopIntegrationsRepository';
import { enableDisableShopIntegration } from '../commands/EnableDisableShopIntegration';
import ShopIntegrationSubsystemSettings from "../components/ShopIntegrationSubsystemSettings.vue";
import RouterUtils from "@astina/paloma-common-ui/src/util/RouterUtils";
export default /*@__PURE__*/ _defineComponent({
    __name: 'IntegrationConfigDetailsView',
    emits: [
        'close',
        'prev',
        'next'
    ],
    setup(__props, { emit: __emit }) {
        const route = useRoute();
        const emit = __emit;
        const integration = ref(null);
        const integrationName = ref(null);
        const loading = ref(false);
        onMounted(init);
        watch(() => route.params, init);
        function init() {
            integrationName.value = RouterUtils.singleParam(route, 'name');
            loadIntegration();
            events.$on('command.generate_shop_export_profile_password.success', loadIntegration);
        }
        onUnmounted(() => {
            events.$off('command.generate_shop_export_profile_password.success', loadIntegration);
        });
        function loadIntegration() {
            shopIntegrationsRepository
                .get(integrationName.value)
                .then(i => integration.value = i);
        }
        function enableDisable() {
            loading.value = true;
            enableDisableShopIntegration(integration.value.name, integration.value.enabled)
                .then(loadIntegration)
                .finally(() => loading.value = false);
        }
        function closeView() {
            emit('close');
        }
        function prevItem() {
            emit('prev');
        }
        function nextItem() {
            emit('next');
        }
        function integrationStatusFactVariant() {
            if (!integration.value || !integration.value.status) {
                return 'default';
            }
            const status = integration.value.status.status;
            switch (status) {
                case 'ok':
                    return 'success';
                case 'warning':
                case 'error':
                    return 'danger';
                case 'running':
                    return 'info';
                case 'requires_configuration':
                    return 'important';
            }
            return 'default';
        }
        return (_ctx, _cache) => {
            const _component_icon = _resolveComponent("icon");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("header", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                        _createElementVNode("a", {
                            onClick: _cache[0] || (_cache[0] = _withModifiers(($event) => (prevItem()), ["prevent"])),
                            class: "data-item__nav-item",
                            href: ""
                        }, [
                            _createVNode(_component_icon, { name: "angle-left" })
                        ]),
                        _cache[4] || (_cache[4] = _createTextVNode()),
                        _createElementVNode("a", {
                            onClick: _cache[1] || (_cache[1] = _withModifiers(($event) => (closeView()), ["prevent"])),
                            class: "data-item__nav-item",
                            href: ""
                        }, [
                            _createVNode(_component_icon, { name: "times" })
                        ]),
                        _cache[5] || (_cache[5] = _createTextVNode()),
                        _createElementVNode("a", {
                            onClick: _cache[2] || (_cache[2] = _withModifiers(($event) => (nextItem()), ["prevent"])),
                            class: "data-item__nav-item",
                            href: ""
                        }, [
                            _createVNode(_component_icon, { name: "angle-right" })
                        ])
                    ]),
                    _cache[10] || (_cache[10] = _createTextVNode()),
                    (integration.value)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createElementVNode("h2", _hoisted_4, _toDisplayString(_ctx.$t('shop_integration')), 1),
                            _cache[8] || (_cache[8] = _createTextVNode()),
                            _createElementVNode("h1", _hoisted_5, _toDisplayString(integration.value.label), 1),
                            _cache[9] || (_cache[9] = _createTextVNode()),
                            _createElementVNode("div", _hoisted_6, [
                                (integration.value.status)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                                        (integration.value.status.statusMessage)
                                            ? (_openBlock(), _createBlock(Fact, {
                                                key: 0,
                                                label: _ctx.$t('status'),
                                                value: integration.value.status.statusMessage,
                                                variant: integrationStatusFactVariant()
                                            }, null, 8, ["label", "value", "variant"]))
                                            : _createCommentVNode("", true)
                                    ]))
                                    : (_openBlock(), _createElementBlock("div", _hoisted_8, [
                                        _createVNode(Fact, {
                                            label: _ctx.$t('status'),
                                            value: _ctx.$t('disabled')
                                        }, null, 8, ["label", "value"])
                                    ])),
                                _cache[6] || (_cache[6] = _createTextVNode()),
                                _cache[7] || (_cache[7] = _createElementVNode("div", { class: "data-item__actions" }, null, -1))
                            ])
                        ], 64))
                        : (_openBlock(), _createBlock(Spinner, {
                            key: 1,
                            loading: !integration.value
                        }, null, 8, ["loading"]))
                ]),
                _cache[18] || (_cache[18] = _createTextVNode()),
                _createElementVNode("div", _hoisted_9, [
                    (integration.value)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createElementVNode("section", _hoisted_10, [
                                (integration.value.description)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(integration.value.description), 1))
                                    : _createCommentVNode("", true),
                                _cache[11] || (_cache[11] = _createTextVNode()),
                                (integration.value.manualUrl)
                                    ? (_openBlock(), _createElementBlock("a", {
                                        key: 1,
                                        href: integration.value.manualUrl,
                                        target: "_blank"
                                    }, [
                                        _createTextVNode(_toDisplayString(_ctx.$t('shop_integration.manual')) + " ", 1),
                                        _createVNode(_component_icon, { name: "external-link-alt" })
                                    ], 8, _hoisted_12))
                                    : _createCommentVNode("", true)
                            ]),
                            _cache[16] || (_cache[16] = _createTextVNode()),
                            _createElementVNode("section", _hoisted_13, [
                                _createElementVNode("h3", _hoisted_14, _toDisplayString(_ctx.$t('shop_integration.settings')), 1),
                                _cache[15] || (_cache[15] = _createTextVNode()),
                                _createElementVNode("div", _hoisted_15, [
                                    _createElementVNode("div", _hoisted_16, [
                                        _withDirectives(_createElementVNode("input", {
                                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((integration.value.enabled) = $event)),
                                            onChange: enableDisable,
                                            disabled: loading.value,
                                            type: "checkbox",
                                            id: "integration-enable",
                                            class: "form__control"
                                        }, null, 40, _hoisted_17), [
                                            [_vModelCheckbox, integration.value.enabled]
                                        ]),
                                        _cache[12] || (_cache[12] = _createTextVNode()),
                                        _cache[13] || (_cache[13] = _createElementVNode("label", { for: "integration-enable" }, null, -1))
                                    ]),
                                    _cache[14] || (_cache[14] = _createTextVNode()),
                                    _createElementVNode("span", _hoisted_18, [
                                        (loading.value)
                                            ? (_openBlock(), _createBlock(Spinner, {
                                                key: 0,
                                                loading: true
                                            }))
                                            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                                _createTextVNode(_toDisplayString(_ctx.$t(integration.value.enabled ? 'enabled' : 'disabled')), 1)
                                            ], 64))
                                    ])
                                ])
                            ]),
                            _cache[17] || (_cache[17] = _createTextVNode()),
                            (integration.value.active && integration.value.status)
                                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(integration.value.status.subSystems, (subsystem, index) => {
                                    return (_openBlock(), _createBlock(ShopIntegrationSubsystemSettings, {
                                        key: index,
                                        integration: integration.value,
                                        subsystem: subsystem
                                    }, null, 8, ["integration", "subsystem"]));
                                }), 128))
                                : _createCommentVNode("", true)
                        ], 64))
                        : _createCommentVNode("", true)
                ])
            ]));
        };
    }
});
